var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_629_108299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 19,
    stroke: "#520408",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 16.875H18.375V23.125H19.625V16.875Z",
    fill: "#520408"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 16.875H20.875V23.125H22.125V16.875Z",
    fill: "#520408"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 16.875H23.375V23.125H24.625V16.875Z",
    fill: "#520408"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 16.875H25.875V23.125H27.125V16.875Z",
    fill: "#520408"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 16.875H28.375V23.125H29.625V16.875Z",
    fill: "#520408"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 26.25H16.5C16.1686 26.2496 15.8509 26.1178 15.6165 25.8835C15.3822 25.6491 15.2504 25.3314 15.25 25V15C15.2504 14.6686 15.3822 14.3509 15.6165 14.1165C15.8509 13.8822 16.1686 13.7504 16.5 13.75H31.5C31.8314 13.7504 32.1491 13.8822 32.3835 14.1165C32.6178 14.3509 32.7496 14.6686 32.75 15V25C32.7496 25.3314 32.6178 25.6491 32.3835 25.8835C32.1491 26.1178 31.8314 26.2496 31.5 26.25ZM16.5 15V25H31.5V15H16.5Z",
    fill: "#520408"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_629_108299",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_108299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_108299",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceLegend);
export default __webpack_public_path__ + "static/media/serviceLegend.d36d4e7d8c8b420038113898fae52e6f.svg";
export { ForwardRef as ReactComponent };